export const environment = {
  production: false,
  apiUrl: 'https://backend-staging.braidsbook.com/api/admin',
  baseUrl: 'https://backend-staging.braidsbook.com'
};